module.exports = __webpack_public_path__ + "img/06.36654ea1.png";